import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { watchValues, watchAll, getValues } from '@dbk-legacy/muster/utils';

export default () => muster()
  .path('app.user.selectedPortfolioId', variable())
  .path('app.user.selectedPortfolioData', variable())
  .path('app.user.portfoliosData', variable([]))
  .path('app.user.cacheId', variable(Date.now()))
  .path('app.user.selectedPortfolio', variable())
  .path('app.user.portfolios', variable())
 
  .match('app.user.selectedPortfolio.*',
    (requests, { get }) =>
      watchValues(get(['app.user.selectedPortfolioId']))
        .map(([portfolioId]) =>
          requests.map(({ req, res }) => {
            return res.redirect(`roster.data.portfoliosById["${portfolioId}"].${req.params['*']}`);
          }))
  )
  .path('app.user.selectedPortfolio.destinationCurrency',
    ({ res }, { get }) =>
      getValues(get(['app.user.selectedPortfolio.referenceCurrency', 'auth.destinationCurrency']))
        .then(([portfolioCurrency, userCurrency]) =>
          res.value(userCurrency || portfolioCurrency)
        ))
  // .path('app.user.portfolios.length', ({ res }, { get }) => {
  //   return res.redirect('roster.data.portfolios.length');
  //   }
  // )
  .path('app.user.portfolios.length', variable(0))
  .match('app.user.portfolios[{integers:portfolioIndex}].*',
    (requests) =>
      requests.map(({ req, res }) =>
        res.redirect(
          `roster.data.portfolios[${[req.params.portfolioIndex]}].${req.params['*']}`
        )
      )
  )
  .match('app.user.portfolios[{integers:portfolioIndex}].dayChange.percent',
    (requests, { get }) =>
      watchValues(get(requests.map(({ req }) =>
        `app.user.portfolios[${req.params.portfolioIndex}].id`)))
        .map(ids =>
          requests.map(({ res }, index) =>
            res.redirect(
              `roster.data.portfoliosById["${ids[index]}"].overallMarketValue.dayChange.percent`
            ))
        ))
  .path('app.user.portfolios.lengthForRange', ({ res }, { get }) =>
    watchAll(get('roster.portfolios.length'))
      .map(([{ value }]) => ({
        path: 'app.user.portfolios.lengthForRange',
        value: value - 1,
      })))
  .path('app.user.portfolioSelection', {
    call: async ({ req }, { get, set, call }) => {
      const [pfId, pfData] = req.args;
      await set('app.user.selectedPortfolioId', pfId);
      await set('app.user.selectedPortfolioData', pfData);
      await set('app.user.selectedPortfolio', pfData);
    }
  })
